import {gql} from "@apollo/client";
import {ApolloClientQuery} from "./_setup";

const GET_TURNSTILE_CONFIG = gql`
    query getTurnstileConfig($userType: String) {
        getTurnstileConfig(userType: $userType) {
            ... on TurnstileConfig {
                isEnabled
                siteKey
                enabledActions
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

// public: the sign-in pages need it before anyone is signed in
export async function getTurnstileConfigQuery() {
    const execute = await ApolloClientQuery(GET_TURNSTILE_CONFIG, {userType: "client"}, false, "network-only");
    return execute?.getTurnstileConfig;
}
